

import React, { useEffect, useRef } from "react";
import CourseCard from "./CourseCard";
import courseMern from "../assets/course-mern.jpg";
import courseData from "../assets/course-data.jpg";
import coursePython from "../assets/course-python.jpg";
import courseFullstack from "../assets/course-fullstack.jpg";
import courseMarketing from "../assets/course-marketing.jpg";
import courseReact from "../assets/course-react.jpg";
import coursedevops from "../assets/devops.png";
import coursecyber from "../assets/cyber.jpg";
import "./Courses.css";

const Courses = () => {
  const courses = [
    {
      image: courseMern,
      title: "FullStack MERN Course",
      description:
        "We offer a comprehensive MERN stack course designed for students of all levels.",
      category: "Certification Program",
      rating: "4.9",
      interviews: "15+",
      link: "/course-mern",
    },
    {
      image: courseData,
      title: "Data Analytics Course",
      description:
        "An extensive industry-relevant Data Analytics course with Placement Assistance!",
      category: "Master Program",
      rating: "4.9",
      interviews: "10+",
      link: "/course-data",
    },
    {
      image: coursePython,
      title: "Python Django Course",
      description:
        "Django is a Python-based full stack web development framework.",
      category: "Programming",
      rating: "4.9",
      interviews: "15+",
      link: "/course-python",
    },
    {
      image: courseFullstack,
      title: "Fullstack Training Course",
      description:
        "Master both frontend and backend development with our comprehensive training.",
      category: "Master Program",
      rating: "4.9",
      interviews: "12+",
      link: "/course-fullstack",
    },
    {
      image: courseMarketing,
      title: "Digital Marketing Course",
      description:
        "Welcome to Codex Future, where we provide training that upskills you.",
      category: "Master Program",
      rating: "4.9",
      interviews: "10+",
      link: "/course-marketing",
    },
    {
      image: courseReact,
      title: "ReactJS Course",
      description:
        "Learn modern React development with hooks, context, and best practices.",
      category: "Programming",
      rating: "4.9",
      interviews: "18+",
      link: "/course-react",
    },


{
      image: coursedevops,
      title: "DevOps Course",
      description:
        "Learn DevOps practices to automate, deploy, and manage applications efficiently.",
      category: "Master Program",
      rating: "4.9",
      interviews: "10+",
      link: "/course-devops",
    },
    {
      image: coursecyber,
      title: "Cyber Security Course",
      description:
        "Learn how to secure computers, networks, and data from cyber attacks.",
      category: "Programming",
      rating: "4.9",
      interviews: "15+",
      link: "/course-cybersecurity",
    },


  ];

  const sectionRef = useRef(null);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll(".card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.25 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="courses" className="courses" ref={sectionRef}>
      <div className="courses-container">
        <div className="courses-header">
          <span className="courses-subtitle">Our Most Popular Courses</span>
          <h2 className="courses-title">
            These are the top short term job-oriented Courses
          </h2>
          <p className="courses-description">
            Certification courses which are in high demand in 2025
          </p>
        </div>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <div key={index} className="card">
              <CourseCard {...course} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
